import { SyntheticEvent } from 'react';

export const smoothScrollTo = (targetY: number, duration: number) => {
    const startY = window.scrollY;
    const difference = targetY - startY;
    let startTime: number | null = null;

    function animation(currentTime: number) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const nextStep = ease(timeElapsed, startY, difference, duration);
        window.scrollTo(0, nextStep);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t: number, b: number, c: number, d: number) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
};

export const scrollToElement = (element: HTMLElement | null | undefined, offset = 0, duration = 1000) => {
    setTimeout(() => {
        const boundaries = element?.getBoundingClientRect();
        if (boundaries) {
            const targetY = boundaries.top - offset;
            duration === 0 ? window.scrollTo(0, targetY) : smoothScrollTo(targetY, duration);
        }
    }, 0);
};


export const preventGlobalScroll = () => {
    const rootElem = document.getElementById('root')!;
    const initialBodyPosition = document.body.style.position;
    const initialBodyOverscrollBehavior = document.body.style.overscrollBehavior;
    const initialHtmlPosition = document.documentElement.style.position;
    const initialHtmlOverscrollBehavior = document.documentElement.style.overscrollBehavior;
    const initialOverflow = rootElem.style.overflow;

    document.body.style.position = 'fixed';
    document.body.style.overscrollBehavior = 'contain';
    document.documentElement.style.position = 'fixed';
    document.documentElement.style.overscrollBehavior = 'contain';
    rootElem.style.overflow = initialOverflow;

    return () => {
        document.documentElement.style.position = initialHtmlPosition;
        document.documentElement.style.overscrollBehavior = initialHtmlOverscrollBehavior;
        document.body.style.position = initialBodyPosition;
        document.body.style.overscrollBehavior = initialBodyOverscrollBehavior;
        rootElem.style.overflow = initialOverflow;
    };
};

export const preventTouchMove = () => {
    const handleTouchMove = () => {
        const activeElement = document.activeElement as HTMLElement;
        activeElement?.blur?.();
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: true });

    return () => {
        document.removeEventListener('touchmove', handleTouchMove);
    };
};
